/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIPatchedStoragePositionRequest
 */
export interface APIPatchedStoragePositionRequest {
    /**
     * 
     * @type {string}
     * @memberof APIPatchedStoragePositionRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedStoragePositionRequest
     */
    comment?: string;
}

/**
 * Check if a given object implements the APIPatchedStoragePositionRequest interface.
 */
export function instanceOfAPIPatchedStoragePositionRequest(value: object): value is APIPatchedStoragePositionRequest {
    return true;
}

export function APIPatchedStoragePositionRequestFromJSON(json: any): APIPatchedStoragePositionRequest {
    return APIPatchedStoragePositionRequestFromJSONTyped(json, false);
}

export function APIPatchedStoragePositionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedStoragePositionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function APIPatchedStoragePositionRequestToJSON(value?: APIPatchedStoragePositionRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'comment': value['comment'],
    };
}

